export const PETROL = 'Petrol'
export const DIESEL = 'Diesel'
export const CITY = 'City'
export const PRICE = 'Price'
export const STATE = 'State'
